export const TRANSLATION_MANAGE_COLLABORATORS = {
  buttonNext: 'global.button.next',
  buttonStart: 'global.button.start',
  hero: {
    collaboratorsManagementSection: {
      title: 'global.manage_collaborators.main',
      subtitle: 'global.description.select_option'
    },
    deleteSubscriptionsSection: {
      title: 'delete_suscriptions.hero.title',
      subtitle: 'global.input_emails.main'
    },
    uploadCollaboratorsSection: {
      generalTitle: 'global.add_collaborator.main',
      selectPlan: {
        subtitle: 'add_collaborator.select_plan.title'
      },
      manageEmails: {
        subtitle: 'global.input_emails.main'
      },
      uploadByFile: {
        subtitle: 'global.upload_file.main'
      },
      selectUploadMethod: {
        title: 'add_collaborator.select_plan.title',
        subtitle: 'global.description.select_option'
      },
      checkout: {
        subtitle: 'collaborators.add_collaborators.checkout.header.description'
      }
    },
    addDependents: {
      title: 'global.add_family_addons.main',
      subtitle: 'global.upload_file.instruction.main'
    }
  },
  loadingText: 'collaborators.add_collaborators.loading_screen.description',
  country: {
    key: 'csp.country.',
    international: 'global.international.main'
  },
  manageCollaboratorsOptions: {
    addCollaboratorsCard: {
      title: 'add_collaborators.card.title',
      description: 'add_collaborators.card.description'
    },
    deleteCollaboratorsCard: {
      title: 'delete_suscriptions.card.title',
      description: 'delete_suscriptions.card.description'
    },
    addDependentsCard: {
      title: 'global.add_family_addons.main',
      description: 'add_family_addons.global.invitation.description',
      tooltip: 'add_family_addon.mexico.temporal_disabled.tooltip'
    }
  },
  uploadCollaboratorsSection: {
    addons: 'global.card_plan.addons_pill.multiple_benefits',
    uploadByEmails: {
      title: 'delete_suscriptions.input_emails.title',
      planLabel: 'global.plan.main',
      addDescription: 'add_collaborators.counter.description',
      collaboratorsCounter: 'collaborators.counter.number_of_users'
    },
    selectUploadMethod: {
      emailTitle: 'global.input_emails.main',
      emailDescription: 'collaborators.add_collaborators.select_method.input_emails.description',
      emailDisclaimer: 'collaborators.add_collaborators.select_method.input_emails.disclaimer',
      fileTitle: 'global.upload_file.main',
      fileDescription: 'collaborators.add_collaborators.select_method.upload_file.description',
      fileDisclaimer: 'collaborators.add_collaborators.select_method.upload_file.disclaimer'
    },
    toast: {
      titleOmitedCollaborators: 'collaborators.add_collaborators.toast.ommited_alert.title',
      subtleOmitedCollaborators: 'collaborators.add_collaborators.toast.ommited_alert.description',
      timeOutTitle: 'delete_suscriptions.time_out.toast.title',
      timeOutSubtle: 'delete_suscriptions.time_out.toast.description'
    },
    checkout: {
      licenses: 'global.licenses.main',
      available: 'global.available.main',
      needToAdd: 'global.need_to_add.main',
      totalToAdd: 'global.total_to_add.main',
      checkoutDescription: 'global.checkout.license_price.description',
      fixedChargeDescription: 'global.checkout.fixed_price.description',
      costPerUser: 'global.cost_per_user.main',
      counterDescription: 'add_collaborators.counter.description',
      emptyState: {
        title: 'collaborators.add_collaborators.exceed_licenses_error.title',
        description: 'collaborators.add_collaborators.exceed_licenses_error.description',
        buttonContact: 'global.button.contact_me',
        buttonReset: 'global.upload_file.reset_file.button',
        toast: {
          title: 'global.registered_request.main',
          description: 'global.contact_me.toast.description',
          errorTitle: 'global.toast.error.title',
          errorDescription: 'global.toast.error.description'
        }
      },
      chargeTypes: {
        exceedsLicenseses: 'collaborators.add_collaborators.checkout.info.exceeds_licenses',
        notExceedsLicenses: 'collaborators.add_collaborators.checkout.info.not_exceeds_licenses',
        onboarding: 'collaborators.add_collaborators.checkout.info.onboarding',
        nomina: 'collaborators.add_collaborators.checkout.info.exceeds_licenses',
        freePlan: 'collaborators.add_collaborators.checkout.info.free_plan',
        monthlyFixed: 'collaborators.add_collaborators.checkout.info.monthly_fixed'
      },
      button: 'global.button.end'
    },
    subscriptionByFile: {
      title: 'global.upload_file.download_and_complete_template.main',
      downloadTemplate: 'global.upload_file.download_template.description',
      downloadTemplateButton: 'global.download_template.main',
      helperButton: 'global.upload_file.helper.how_to_complete',
      informativeModal: {
        title: 'global.upload_file.helper.how_to_complete',
        description: 'global.upload_file.helper.description',
        items: {
          name: 'global.name_last_name.main',
          birthDate: 'global.date_of_birth_main',
          id: 'global.id.main',
          gender: 'global.gender.main',
          email: 'global.email.main',
          salary: 'collaborator.rent_details.salary.main',
          hoursWorked: 'collaborator.rent_details.hours_worked.main',
          zipCode: 'global.zip_code.main'
        },
        infoCard: 'global.upload_file.helper.information_banner'
      },
      table: {
        name: 'global.name.main',
        email: 'global.email.main',
        statusCard: 'global.upload_file.error_banner',
        fatherLastName: 'global.father_last_name.main',
        motherLastName: 'global.mother_last_name.main',
        dateOfBrithday: 'global.date_of_birth_main',
        gender: 'global.gender.main',
        salary: 'collaborator.rent_details.salary.main',
        hoursWorked: 'collaborator.rent_details.hours_worked.main',
        zipCode: 'global.zip_code.main',
        emptyField: 'global.empty_field.error_placeholder',
        identification: 'global.id.main',
        docType: 'global.id_type.main',
        withoutErrors: {
          title: 'global.upload_file.errors_view.empty_state.title',
          description: 'global.upload_file.errors_view.empty_state.description'
        },
        actionBar: {
          selected: 'global.action_bar.selected_items',
          delete: 'global.delete_from_list.main'
        },
        toast: {
          deleteSucess: 'global.delete_from_list.toast.success',
          button: 'global.button.undo'
        }
      }
    }
  },

  deleteSubscriptionsSection: {
    title: 'delete_suscriptions.input_emails.title',
    counterDescription: 'delete_suscriptions.counter.description',
    numberOfDescription: 'collaborators.counter.number_of_suscriptions',
    textAreaPlaceholder: 'input_emails.placeholder',
    checkEmails: {
      sucess: 'global.check_emails.success.banner',
      alert: 'delete_suscriptions.check_emails.alert.banner'
    }
  },

  addDependentsCard: {
    modal: {
      title: 'add_family_addons.not_supported_plans.dialog.title',
      description: 'add_family_addons.not_supported_plans.dialog.description',
      button: 'button.understood'
    },
    addDependentsByFile: {
      title: 'global.upload_file.download_and_complete_template.main',
      downloadTemplate: 'global.upload_file.download_template.description',
      downloadTemplateButton: 'global.download_template.main',
      helperButton: 'global.upload_file.helper.how_to_complete',
      addDescription: 'add_collaborators.counter.description',
      numberOfFamily: 'add_family_addon.counter.number_of_family',
      addDependentsButton: 'global.add_familiy_addons.button',
      informativeModal: {
        title: 'global.upload_file.helper.how_to_complete',
        description: 'add_family_addon.upload_file.helper.description',
        items: {
          collaboratorId: 'global.collaborator_id.by_type.main',
          relationship: 'global.family_relationship.main',
          name: 'global.family_member_name.main',
          id: 'global.family_member_id.main',
          gender: 'global.family_member_gender.main',
          birthday: 'global.family_member_birthdate.main'
        },
        infoCard: 'add_family_addon.upload_file.helper.information_banner'
      },
      table: {
        memberId: 'global.collaborator_id.main',
        dependentId: 'family_addons.global.dependent_id.main',
        docType: 'family_addons.global.id_type.main',
        firstLastName: 'family_addons.global.dependent_first_lastname.main',
        secondLastName: 'family_addons.global.dependent_second_lastname.main',
        name: 'family_addons.global.dependent_name.main',
        relationship: 'global.family_relationship.main',
        birthDate: 'global.date_of_birth_main',
        gender: 'global.gender.main',
        lastName: 'family_addons.global.dependent_lastname.main',
        notInformed: 'global.not_informed.main',
        emptyField: 'global.empty_field.error_placeholder',
        statusCard: 'global.upload_file.error_banner',
        withoutErrors: {
          title: 'global.upload_file.errors_view.empty_state.title',
          description: 'family_addons.upload_file.errors_view.empty_state.description'
        },
        actionBar: {
          selected: 'global.action_bar.selected_items',
          delete: 'global.delete_from_list.main'
        },
        toast: {
          deleteSucess: 'global.delete_from_list.toast.success',
          button: 'global.button.undo'
        }
      }
    }
  }
};
